"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BackgroundContainerDefaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BackgroundContainer = function BackgroundContainer(props) {
  var classNames = props.classNames,
      id = props.id,
      children = props.children,
      type = props.type;
  var backgroundClasses = (0, _classnames.default)('background-container', ["background-container-".concat(type)], classNames);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: backgroundClasses
  }, children);
};

BackgroundContainer.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired,
  type: _propTypes.default.oneOf(['shadow', 'screen', 'semi-transparent', 'message']).isRequired
};
var BackgroundContainerDefaultProps = {
  classNames: '',
  id: ''
};
exports.BackgroundContainerDefaultProps = BackgroundContainerDefaultProps;
BackgroundContainer.defaultProps = BackgroundContainerDefaultProps;
var _default = BackgroundContainer;
exports.default = _default;